import "./newTicketSolved.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import newRequest from "../../context/newRequest";
import {sleep} from "../../services/help";

const NewTicketSolved = ({ inputs, title }) => {
  const [ticketSolved, setTicketSolved] = useState({});
  const [ticketOpen, setTicketOpen] = useState({})
  const [categoryId, setCategoryId] = useState(false);
  const [statusId, setStatusId] = useState(["SOLVED"]);
  const [sending, setSending] = useState("");
  const { ticketId } = useParams();
  const user = localStorage.getItem("user");
  const { data, loading, error } = useFetch(`/ticket/${ticketId}`);
  const navigate = useNavigate();

  useEffect(() => {
    setTicketOpen(data);
  }, [data]);

  const handleSelectCategoryID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setCategoryId(value);
  };

  const handleSelectStatusID = (e) => {
    const value = Array.from(
        e.target.selectedOptions,
        (option) => option.value
    );
    setStatusId(value);
  };

  const handleChange = (e) => {
    setTicketSolved((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };


  const handleClick = async (e) => {
    e.preventDefault();
    setSending("Menegchek apakah sudah di solved apa belum")
    if (ticketOpen.status_id == "SOLVED") {
      try {
      setSending("On Submit")
        await sleep(2000)
        setSending("Mengirim Submit")
      const newTicketSolved = {
        ...ticketSolved,
        category_id : categoryId[0],
        status_id : statusId[0]
      };

      const res= await newRequest.post(`/solve/${ticketId}`, newTicketSolved, {
        // headers
        headers: {
          'Authorization': `$Bearer ${user.token}`
        },
      });
      setSending("Mengirim")

      if (res.status === 200) {
        setSending("Berhasil mengirim data")

        navigate(`/solve/${ticketId}`);
      }
    } catch (err) {
      setSending(err.response.data.errors)
      console.log(err);
    }
    } else {
      setSending("Ticket BELUM di Solved, HARUS DI SOLVED DAHULU di table Open Ticket")
    }

};
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="right">
            <form>
              <div>
                {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input type={input.type} placeholder={input.placeholder} onChange={handleChange} id={input.id}/>
                    </div>
                ))}
                <div className="formInput">
                  <label>Status</label>
                  <select id="status_id" onChange={handleSelectStatusID}>
                    <option value="SOLVED">Solved</option>
                    <option value="CLOSED">Closed</option>
                    <option value="PENDING">Pending</option>
                  </select>
                <label >Category</label>
                  <select id="category_id" onChange={handleSelectCategoryID}>
                    <option value="DOWN">Down</option>
                    <option value="UP">UP Internet</option>
                    <option value="ONUBAD">ONU Bad</option>
                    <option value="DISCON">Internet Diconnected</option>
                    <option value="FIBERCUT">Fiber Cut</option>
                    <option value="POWEROFF">Power OFF</option>
                    <option value="INTERMITTEN">INTERMITTEN</option>
                    <option value="LOOPING">LOOPING</option>
                    <option value="BENDING">BENDING</option>
                  </select>
                </div>

                <div className="segment">

                  <label>Segment Customer </label>
                  <textarea placeholder="segmet customer" onChange={handleChange} id="segment_customer"/>
                </div>
                <button onClick={handleClick}>Send</button>
              </div>
              {sending && <p className="error">{sending}</p>}

            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewTicketSolved;
